import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import Disclaimer from '../Disclaimer';
import { withTranslation, Trans } from 'react-i18next';
import { view011ImageOptions } from './views/view011'

class Summary extends Component {
	constructor(props) {
		super(props);

		this.state = {
			expanded: false
		};
	}

	render() {
		let imageOptions = view011ImageOptions;

        let image = (
			<ConfiguratorImage boat="Xpower" configuration={this.props.configuration.exterior} options={imageOptions} />
        );

		return (
			<ConfiguratorSection image={image}>

				<ConfiguratorOption style={{ position: 'relative' }}>

					<h1><Trans defaults='Summary' /></h1>
					<h2><Trans defaults='Congratulations!' /></h2>
					<p><Trans defaults='You have now configured the basics of an X-Power 33C. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>

                    <PdfForm disablePreowned boat="xpower" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />

					<ShareFrom configuration={this.props.configuration} boat="xpower" code={this.props.code} />

					<Disclaimer />
				</ConfiguratorOption>
			</ConfiguratorSection>
		);
	}
}

export default withTranslation()(Summary);


// WEBPACK FOOTER //
// ./src/Xpower/Summary.js